import React from 'react';

const NotFound = () => {
  return <>NOT FOUND</>;
};

export default NotFound;
